import React, { useState, useContext, useEffect, useRef } from 'react'
// import styles from "../../scss/"
import { Toast } from 'primereact/toast'
import { Tooltip } from 'primereact/tooltip'
import Modals from '../shared/Modals'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Spinner,
} from 'reactstrap'
import { AuthenticationContext } from '../../Auth/authentication.context'
import { useBranding } from '../../contexts/BrandingContext'
import { ToastPopUp } from '../shared/utils'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import PlacesAutocomplete from '../shared/PlacesAutoComplete'
import { Checkbox } from 'primereact/checkbox'
import EditUserProfileInfo from './editUserProfileInfo'
import server from '../../server'
import { Message } from 'primereact/message'
import PaymentModal from '../shared/PaymentModal'
import BankInfoModal from '../shared/BankInfoModal'
import DeleteModal from '../shared/DeleteModal'
import { Button as PrimeButton } from 'primereact/button'

const UserProfile = (props) => {
  const { isGroupMode } = useBranding()
  const {
    user,
    isAdmin,
    toastStatus,
    onProfileUpdate,
    onChangePasswordProfile,
    onGetUserData,
    loading,
    success,
    status,
  } = useContext(AuthenticationContext)

  const toast = useRef(null)
  const [isOwnerContactDifferent, setIsOwnerContactDifferent] = useState(true)
  const [ownerPhone, setOwnerPhone] = useState(
    user?.pharmacyOwnerTelephone || ''
  )
  const [ownerEmail, setOwnerEmail] = useState(user?.pharmacyOwnerEmail || '')
  const [editMode, setEditMode] = useState(false)
  const [editDisplayName, setEditDisplayName] = useState('')
  const [editName, setEditName] = useState(user?.legalName)
  const [editTradeName, setEditTradeName] = useState(user?.tradeName)
  const [editAccreditationNo, setAccreditationNo] = useState('')
  const [editTelephone, setEditTelephone] = useState(user?.telephone)
  const [editFax, setEditFax] = useState(user?.fax)
  const [editPharmacyOwnerName, setEditPharmacyOwnerName] = useState(
    user?.pharmacyOwnerName
  )
  const [editPharmacyOwnerTelephone, setEditPharmacyOwnerTelephone] =
    useState('')
  const [editPharmacyOwnerEmail, setEditPharmacyOwnerEmail] = useState('')
  const [changePasswordMode, setChangePasswordMode] = useState(false)
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(
    user?.shippingAddress
  )
  const [userLoading, setUserLoading] = useState(false)

  const [originsDirectModule, setOriginsDirectModule] = useState('')
  const [originsManagementModule, setOriginsManagementModule] = useState('')
  const [isPharmacistInfoDifferent, setIsPharmacistInfoDifferent] =
    useState(false)
  const isPartOfGroup = Boolean(user?.pharmacyGroup || user?.pharmacyGroupId)
  const canSeeSuppliers = Boolean(originsManagementModule) || isPartOfGroup

  // Initialize state for Pharmacy Owner's phone and email
  const [pharmacyOwnerTelephone, setPharmacyOwnerTelephone] = useState(
    user.pharmacyOwnerTelephone || ''
  )
  const [pharmacyOwnerEmail, setPharmacyOwnerEmail] = useState(
    user.pharmacyOwnerEmail || ''
  )
  const [paymentProfiles, setPaymentProfiles] = useState([])
  const [bankProfiles, setBankProfiles] = useState([])
  const [showTooltip, setShowTooltip] = useState(false)

  // Payment and Bank Modal States
  const [paymentModalVisible, setPaymentModalVisible] = useState(false)
  const [bankInfoModalVisible, setBankInfoModalVisible] = useState(false)
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [deleteBankModalVisible, setDeleteBankModalVisible] = useState(false)
  const [profileToDelete, setProfileToDelete] = useState(null)
  const [bankProfileToDelete, setBankProfileToDelete] = useState(null)
  const [paymentProfileLoading, setPaymentProfileLoading] = useState(false)
  const [bankProfileLoading, setBankProfileLoading] = useState(false)

  console.log('profilesss', paymentProfiles)
  console.log('bankProfiles', bankProfiles)
  const handleOwnerContactChange = (e) => {
    setIsOwnerContactDifferent(e.checked)
    if (!e.checked) {
      // If checkbox is unchecked, clear the owner phone and email
      setOwnerPhone('')
      setOwnerEmail('')
    }
  }
  const module = localStorage.getItem('module')
  // Check if pharmacy owner's phone or email exists, and auto-check the box
  useEffect(() => {
    if (pharmacyOwnerTelephone || pharmacyOwnerEmail) {
      setIsPharmacistInfoDifferent(true) // Automatically check the box
    }
  }, [pharmacyOwnerTelephone, pharmacyOwnerEmail])

  useEffect(() => {
    const originsDirect = user?.pharmacyModules?.find(
      (module) => module.name === 'Origins Direct'
    )
    if (originsDirect) {
      setOriginsDirectModule(originsDirect.name)
    }

    const originsManagement = user?.pharmacyModules?.find(
      (module) => module.name === 'Origins Management'
    )
    if (originsManagement) {
      setOriginsManagementModule(originsManagement.name)
    }
  }, [user])
  useEffect(() => {
    if (toastStatus?.toastStatus) {
      ToastPopUp(toast, toastStatus?.toastStatus, toastStatus?.msg)
    }
  }, [toastStatus])

  const handlePasswordSubmit = () => {
    if (
      currentPassword !== '' &&
      newPassword !== '' &&
      confirmPassword !== ''
    ) {
      onChangePasswordProfile(
        currentPassword,
        newPassword,
        confirmPassword
      ).then(() => {
        // onGetUserData()
        setEditMode(false)
        setUserLoading(true)
      })
    }
  }

  const handleEditSubmit = () => {
    // Check if the phone and email should be sent as null
    const updatedPharmacyOwnerTelephone = isOwnerContactDifferent
      ? ownerPhone
      : null

    const updatedPharmacyOwnerEmail = isOwnerContactDifferent
      ? ownerEmail
      : null

    // Call the onProfileUpdate function with the prepared data
    onProfileUpdate(
      editDisplayName,
      editName,
      editTradeName,
      editAccreditationNo,
      selectedAddress,
      editTelephone,
      editFax,
      selectedShippingAddress,
      editPharmacyOwnerName,
      updatedPharmacyOwnerTelephone,
      updatedPharmacyOwnerEmail
    )

    // Update the UI state
    setEditMode(false)
    setUserLoading(true)
  }
  useEffect(() => {
    if (success === true) {
      onGetUserData()
    }
  }, [success])
  useEffect(() => {
    if (loading === false) {
      setUserLoading(false)
    }
  }, [loading])
  const pharmacyModules = user?.pharmacyModules?.map((module, index) => (
    <span
      className='badge bg-primary rounded-pill text-light py-2 px-3 fw-bold mx-1'
      key={index}
    >
      {module.name}
    </span>
  ))

  const manufacturers = () => {
    let manufacturersNames = user?.manufacturers?.map((itm, index) => {
      return (
        <h4 className='m-0' key={index}>
          <span className='badge bg-primary  rounded-pill text-light py-2 px-3 fw-bold '>
            {itm?.name}
          </span>
        </h4>
      )
    })
    return <div className='d-flex gap-2 flex-wrap '>{manufacturersNames}</div>
  }

  // Define callback to receive payment profile data
  const handlePaymentProfileUpdate = (profiles) => {
    setPaymentProfiles(Array.isArray(profiles) ? profiles : [])
  }

  // Define callback to receive bank profile data
  const handleBankProfileUpdate = (profiles) => {
    setBankProfiles(Array.isArray(profiles) ? profiles : [])
  }

  // Add this effect to fetch payment profile on component mount
  useEffect(() => {
    const fetchInitialPaymentProfile = async () => {
      if (!isGroupMode && user?.role === 'pharmacy' && user?.pharmacyModules?.length > 0) {
        try {
          const pharmacyId = user.pharmacyModules[0]?.pharmacyId
          if (pharmacyId) {
            const response = await server.get(
              `/payments/pharmacy-payment-profile/${pharmacyId}`,
              {
              }
            )
            if (response?.data?.paymentProfile) {
              setPaymentProfiles([response.data.paymentProfile])
            }
          }
        } catch (error) {
          console.error('Error fetching initial payment profile:', error)
        }
      }
    }

    fetchInitialPaymentProfile()
  }, [user, isGroupMode])

  // Add this alongside the payment profile useEffect
  useEffect(() => {
    const fetchInitialBankProfile = async () => {
      if (!isGroupMode && user?.role === 'pharmacy' && user?.pharmacyModules?.length > 0) {
        try {
          const pharmacyId = user.pharmacyModules[0]?.pharmacyId
          if (pharmacyId) {
            const response = await server.get(
              `/payments/pharmacy-bank-profile/${pharmacyId}`,
              {
              }
            )
            if (response?.data?.bankProfile) {
              setBankProfiles([response.data.bankProfile])
            }
          }
        } catch (error) {
          console.error('Error fetching initial bank profile:', error)
        }
      }
    }

    fetchInitialBankProfile()
  }, [user, isGroupMode])

  // Payment and Bank Profile Functions
  const fetchPaymentProfile = async (pharmacyId) => {
    setPaymentProfileLoading(true)
    try {
      const response = await server.get(
        `/payments/pharmacy-payment-profile/${pharmacyId}`,
        {
        }
      )
      if (response?.data?.paymentProfile) {
        setPaymentProfiles([response.data.paymentProfile])
      }
    } catch (error) {
      console.error('Error fetching payment profile:', error)
    } finally {
      setPaymentProfileLoading(false)
    }
  }

  const fetchBankProfile = async (pharmacyId) => {
    setBankProfileLoading(true)
    try {
      const response = await server.get(
        `/payments/pharmacy-bank-profile/${pharmacyId}`,
        {
        }
      )
      if (response?.data?.bankProfile) {
        setBankProfiles([response.data.bankProfile])
      }
    } catch (error) {
      console.error('Error fetching bank profile:', error)
    } finally {
      setBankProfileLoading(false)
    }
  }

  const handleDeleteClick = (pharmacyId) => {
    setProfileToDelete(pharmacyId)
    setDeleteModalVisible(true)
  }

  const confirmDeleteProfile = async () => {
    if (profileToDelete) {
      try {
        await server.delete(
          `/payments/pharmacy-payment-profile/${profileToDelete}`,
          {
          }
        )
        setPaymentProfiles([])
        setDeleteModalVisible(false)
      } catch (error) {
        console.error('Error deleting payment profile:', error)
      }
    }
  }

  const handleDeleteBankClick = (pharmacyId) => {
    setBankProfileToDelete(pharmacyId)
    setDeleteBankModalVisible(true)
  }

  const confirmDeleteBankProfile = async () => {
    if (bankProfileToDelete) {
      try {
        await server.delete(
          `/payments/pharmacy-bank-profile/${bankProfileToDelete}`,
          {
          }
        )
        setBankProfiles([])
        setDeleteBankModalVisible(false)
      } catch (error) {
        console.error('Error deleting bank profile:', error)
      }
    }
  }

  document.title = 'Profile | Origins Direct'
  return (
    <React.Fragment>
      <div className='card flex justify-content-center'>
        <Toast ref={toast} />
      </div>
      <div className='page-content'>
        <div className='container-fluid'>
          <div className='d-flex justify-content-between'>
            <h2 className='fs-3 fw-bold  mb-4'>Profile</h2>

            <div className='text-center d-flex gap-2 h-25'>
              {!editMode && (
                <Button
                  type='submit'
                  color='primary'
                  onClick={() =>
                    setChangePasswordMode((prevState) => !prevState)
                  }
                >
                  {changePasswordMode ? 'Back' : 'Change Password'}
                </Button>
              )}

              {!changePasswordMode && (
                <div
                  style={{ position: 'relative', display: 'inline-block' }}
                  onMouseEnter={() => status > 0 && setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                >
                  <Button
                    type='submit'
                    color='primary'
                    className={
                      user.role === 'pharmacy' && !editMode && status === 0
                        ? 'btn-complete-profile'
                        : 'btn-primary'
                    }
                    disabled={status > 0}
                    onClick={() => setEditMode((prevState) => !prevState)}
                  >
                    {user.role !== 'pharmacy'
                      ? editMode
                        ? 'Back'
                        : 'Edit Profile'
                      : editMode
                      ? 'Back'
                      : status === 0
                      ? 'Complete Profile'
                      : 'Edit Profile'}
                  </Button>
                  {showTooltip && status > 0 && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: '10%',
                        transform: 'translateX(-50%)',
                        backgroundColor: '#333',
                        color: 'white',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        zIndex: 1000,
                        marginTop: '5px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                        width: '200px',
                        textAlign: 'left',
                      }}
                    >
                      To request changes to your profile information, please
                      send your request to admin@originssystems.com
                      <div
                        style={{
                          position: 'absolute',
                          bottom: '100%',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          border: '5px solid transparent',
                          borderBottomColor: '#333',
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <Row>
            <Col lg='12'>
              <Card>
                <CardBody>
                  <div className='d-flex'>
                    <div className='row row-cols-2 w-100'>
                      <div className='text-muted'>
                        {user?.role === 'admin' ? (
                          <>
                            <h4 className='mb-2'>{user.displayName}</h4>
                            <h6 className='mb-1'>Admin</h6>
                          </>
                        ) : user?.role === 'pharmacy' ? (
                          <>
                            <h4 className='mb-2'>{user.pharmacyName}</h4>
                            <h6 className='mb-1'>Pharmacy</h6>
                          </>
                        ) : user?.role === 'manufacturer' ? (
                          <>
                            <h4 className='mb-2'>{user.displayName}</h4>
                            <h6 className='mb-1'>Manufacturer</h6>
                          </>
                        ) : null}
                      </div>
                      <div className='text-muted'>
                        {user?.role === 'pharmacy' ? (
                          <>
                            <h4 className='mb-2'>{user.accountNo}</h4>
                            <h6 className='mb-1'>Account Number</h6>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* ============================================================ */}
          {!changePasswordMode && !changePasswordMode && !editMode && (
            <>
              <Card>
                <CardBody>
                  {userLoading ? (
                    <div className='d-flex justify-content-center align-items-center '>
                      <Spinner color='primary' />
                    </div>
                  ) : (
                    <>
                      {!isAdmin && user?.role !== 'manufacturer' && (
                        <h4 style={{ color: '#626ED4' }} className='mt-2 mb-4'>
                          Pharmacy Information
                        </h4>
                      )}

                      <div className='row row-cols-1 row-cols-sm-2 '>
                        {user?.role === 'pharmacy' && (
                          <div className='form-group col '>
                            <Label className='form-label'>Legal Name</Label>
                            <p>{user.legalName}</p>
                          </div>
                        )}
                        {user?.role !== 'pharmacy' && (
                          <div className='form-group col '>
                            <Label className='form-label'>Full Name</Label>
                            <p>{user.displayName}</p>
                          </div>
                        )}
                        {user?.role === 'pharmacy' && (
                          <div className='form-group col'>
                            <Label className='form-label mt-2'>
                              Trade Name / Pharmacy Name
                            </Label>
                            <p>{user.tradeName}</p>
                          </div>
                        )}
                        {user?.role === 'pharmacy' && (
                          <>
                            <div className='form-group col '>
                              <Label className='form-label mt-2'>
                                Accreditation Number
                              </Label>
                              <p>
                                {user.accreditation
                                  ? user.accreditation
                                  : 'There is no accreditation'}
                              </p>
                            </div>
                          </>
                        )}
                        <div className='form-group col '>
                          <Label className='form-label mt-2'>Email</Label>
                          <p>{user.email}</p>
                        </div>

                        {user?.role === 'pharmacy' && (
                          <div className='form-group col '>
                            <Label className='form-label mt-2'>Address</Label>
                            <p>
                              {user.address
                                ? user.address
                                : 'There is no address'}
                            </p>
                          </div>
                        )}
                        {user?.role === 'pharmacy' && (
                          <div className='form-group col '>
                            <Label className='form-label mt-2'>
                              Telephone Number
                            </Label>
                            <p>
                              {user.telephone
                                ? user.telephone
                                : 'There is no Telephone Number'}
                            </p>
                          </div>
                        )}
                        {user?.role === 'pharmacy' && (
                          <div className='form-group col '>
                            <Label className='form-label mt-2'>
                              Fax Number
                            </Label>
                            <p>
                              {user.fax ? user.fax : 'There is no Fax Number'}
                            </p>
                          </div>
                        )}
                        {user?.role === 'pharmacy' && (
                          <>
                            <div className='form-group col '>
                              <Label className='form-label mt-2'>
                                Shipping Address
                              </Label>
                              <p>
                                {user.shippingAddress
                                  ? user.shippingAddress
                                  : 'There is no Shipping Address'}
                              </p>
                            </div>
                          </>
                        )}

                        {user?.role === 'pharmacy' && (
                          <>
                            <h4
                              style={{ color: '#626ED4' }}
                              className='mt-4 mb-4'
                            >
                              Contact Person / Pharmacy Owner Information
                            </h4>
                            <div></div>
                          </>
                        )}
                        {user?.role === 'pharmacy' && (
                          <>
                            <div className='form-group col '>
                              <Label className='form-label mt-2'>Name</Label>
                              <p>
                                {user.pharmacyOwnerName
                                  ? user.pharmacyOwnerName
                                  : 'There is no name'}
                              </p>
                            </div>
                            <div className='form-group col '>
                              <Label className='form-label mt-2'>
                                Telephone number
                              </Label>
                              <p>
                                {user.pharmacyOwnerTelephone
                                  ? user.pharmacyOwnerTelephone
                                  : 'Same as Pharmacy Phone'}
                              </p>
                            </div>
                            <div className='form-group col '>
                              <Label className='form-label mt-2'>Email</Label>
                              <p>
                                {user.pharmacyOwnerEmail
                                  ? user.pharmacyOwnerEmail
                                  : 'Same as Pharmacy Email'}
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </CardBody>
              </Card>
              {user?.role === 'manufacturer' && (
                <Card>
                  <CardBody>
                    <div className='form-group col '>
                      <Label className='form-label'>Manufacturers</Label>
                      <div>{manufacturers()}</div>
                    </div>
                  </CardBody>
                </Card>
              )}
              {!isGroupMode && !isAdmin && user?.role !== 'manufacturer' && (
                <Card>
                  <CardBody>
                    <div className='row row-cols-1 row-cols-sm-2 '>
                      <div className='form-group col '>
                        <Label className='form-label'>Systems</Label>
                        <h4 className='m-0 d-flex flex-wrap gap-2'>
                          {pharmacyModules}
                        </h4>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              )}

              {/* Payment and Banking Information section hidden for pharmacies
                  (feature is disabled until Origins Direct Instant launches). */}
              {false && !isGroupMode && user?.role === 'pharmacy' && (
                <Card>
                  <CardBody>
                    <h4 style={{ color: '#626ED4' }} className=''>
                      Payment and Banking Information
                    </h4>
                    <div className='mb-4 w-100 d-flex justify-content-start'>
                      <Message
                        className='w-100 text-start d-inline-block '
                        severity='info'
                        text='Payment and Banking Information features will be available once Origins Direct Instant is launched. Stay tuned for updates!'
                      />
                    </div>

                    <div className='row mt-3'>
                      {module === 'Origins Direct Instant' &&
                        (paymentProfiles.length === 0 ||
                          bankProfiles.length === 0) && (
                          <div className='mb-4'>
                            <Message
                              severity='info'
                              text='Payment and Banking Information features will be available once Origins Direct Instant is launched. Stay tuned for updates!'
                            />
                          </div>
                        )}
                      <div className='col-md-6'>
                        <div className='card border h-100'>
                          {paymentProfileLoading ? (
                            <div className='card-body d-flex flex-column align-items-center justify-content-center p-4'>
                              <Spinner color='primary' />
                              <p className='mt-2'>
                                Loading payment information...
                              </p>
                            </div>
                          ) : paymentProfiles.length === 0 ? (
                            <div className='card-body d-flex flex-column align-items-center justify-content-center p-4'>
                              <h5 className='mb-4'>Add a Payment Method</h5>
                              <Button
                                color=''
                                className='btn btn-outline-primary'
                                disabled
                                title='This feature will be available once Origins Direct Instant is launched'
                                style={{ opacity: 0.6, cursor: 'not-allowed' }}
                              >
                                <i className='mdi mdi-plus-circle-outline me-1'></i>{' '}
                                Add a Card
                              </Button>
                            </div>
                          ) : (
                            <div className='card-body p-4 d-flex flex-column justify-content-between'>
                              <div>
                                {paymentProfiles.map((profile, index) => (
                                  <div key={index}>
                                    <p className='mb-0 fw-bold'>
                                      <i className='mdi mdi-credit-card me-2'></i>
                                      {profile.payment?.creditCard?.cardType ||
                                        'Visa'}{' '}
                                      {profile.payment?.creditCard?.cardNumber.replace(
                                        'XXXX',
                                        ' ****'
                                      )}
                                    </p>
                                  </div>
                                ))}
                              </div>

                              <div className='mt-4 d-flex gap-2'>
                                <Button
                                  color=''
                                  className='btn btn-outline-primary'
                                  onClick={() => {
                                    const pharmacyId =
                                      user?.pharmacyModules?.[0]?.pharmacyId
                                    if (pharmacyId) {
                                      handleDeleteClick(pharmacyId)
                                    }
                                  }}
                                >
                                  Remove
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className='col-md-6'>
                        <div className='card border h-100'>
                          {bankProfileLoading ? (
                            <div className='card-body d-flex flex-column align-items-center justify-content-center p-4'>
                              <Spinner color='primary' />
                              <p className='mt-2'>
                                Loading bank information...
                              </p>
                            </div>
                          ) : bankProfiles.length === 0 ? (
                            <div className='card-body d-flex flex-column align-items-center justify-content-center p-4'>
                              <h5 className='mb-4'>Add a Bank Information</h5>
                              <Button
                                color=''
                                className='btn btn-outline-primary'
                                disabled
                                title='This feature will be available once Origins Direct Instant is launched'
                                style={{ opacity: 0.6, cursor: 'not-allowed' }}
                              >
                                <i className='mdi mdi-plus-circle-outline me-1'></i>{' '}
                                Add a Bank Information
                              </Button>
                            </div>
                          ) : (
                            <div className='card-body p-4 d-flex flex-column justify-content-between'>
                              <div>
                                {bankProfiles.map((profile, index) => (
                                  <div key={index}>
                                    <p className='mb-0 fw-bold'>
                                      <i className='mdi mdi-bank me-2'></i>
                                      Account:{' '}
                                      {profile.payment?.bankAccount?.accountNumber.replace(
                                        'XXXX',
                                        ' ****'
                                      )}
                                    </p>
                                    <div className='d-flex align-items-center mt-1'>
                                      <span className='me-2 fw-bold'>
                                        Account Holder Name:{' '}
                                        {
                                          profile.payment?.bankAccount
                                            ?.nameOnAccount
                                        }
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </div>

                              <div className='mt-4 d-flex gap-2'>
                                <Button
                                  color=''
                                  className='btn btn-outline-primary'
                                  onClick={() => {
                                    const pharmacyId =
                                      user?.pharmacyModules?.[0]?.pharmacyId
                                    if (pharmacyId) {
                                      handleDeleteBankClick(pharmacyId)
                                    }
                                  }}
                                >
                                  Remove
                                </Button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              )}
            </>
          )}

          {/* ============================================================ */}
          {editMode && (
            <EditUserProfileInfo
              user={user}
              isAdmin={isAdmin}
              editDisplayName={editDisplayName}
              setEditDisplayName={setEditDisplayName}
              editName={editName}
              setEditName={setEditName}
              editTradeName={editTradeName}
              setEditTradeName={setEditTradeName}
              accreditationNo={editAccreditationNo}
              setAccreditationNo={setAccreditationNo}
              selectedShippingAddress={selectedShippingAddress}
              setSelectedShippingAddress={setSelectedShippingAddress}
              editTelephone={editTelephone}
              setEditTelephone={setEditTelephone}
              editFax={editFax}
              setEditFax={setEditFax}
              editPharmacyOwnerName={editPharmacyOwnerName}
              setEditPharmacyOwnerName={setEditPharmacyOwnerName}
              ownerPhone={ownerPhone}
              setOwnerPhone={setOwnerPhone}
              ownerEmail={ownerEmail}
              setOwnerEmail={setOwnerEmail}
              isOwnerContactDifferent={isOwnerContactDifferent}
              handleOwnerContactChange={handleOwnerContactChange}
              handleEditSubmit={handleEditSubmit}
              onProfileUpdate={onProfileUpdate}
              setEditMode={setEditMode}
              setUserLoading={setUserLoading}
              paymentProfileCallback={handlePaymentProfileUpdate}
              bankProfileCallback={handleBankProfileUpdate}
            />
          )}
          {/* ============================================================ */}

          {changePasswordMode && (
            <div>
              <h4 className='card-title mb-4'>Change Password</h4>
              <Card>
                <CardBody>
                  <form className='row row-cols-1 row-cols-sm-2'>
                    <div className='form-group col'>
                      <Label className='form-label mt-3'>
                        Current Password
                      </Label>
                      <input
                        name='currentPassword'
                        className='form-control'
                        placeholder='Enter current password'
                        type='password'
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                      />
                    </div>
                    <div className='form-group col'>
                      <Label className='form-label mt-3'>New Password</Label>
                      <input
                        name='newPassword'
                        className='form-control'
                        placeholder='Enter new password'
                        type='password'
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                    </div>
                    <div className='form-group col'>
                      <Label className='form-label mt-3'>
                        Confirm New Password
                      </Label>
                      <input
                        name='confirmPassword'
                        className='form-control'
                        placeholder='Confirm new password'
                        type='password'
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                    <div> </div>
                    <div className='text-center mt-4 d-flex justify-content-end gap-3 w-100 col-12'>
                      <Button
                        color=''
                        className='btn btn-outline-primary'
                        onClick={() => setChangePasswordMode(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        type='submit'
                        color='primary'
                        onClick={(e) => {
                          e.preventDefault()
                          handlePasswordSubmit()
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  </form>
                </CardBody>
              </Card>
            </div>
          )}
          {!isAdmin && user?.role !== 'manufacturer' && (
            <>
              {canSeeSuppliers && !changePasswordMode && !editMode && (
                <div>
                  <h4 className='card-title mb-4'>Suppliers</h4>
                  <Card>
                    <CardBody>
                      <DataTable
                        value={user?.accounts}
                        dataKey='supplierId'
                        removableSort
                        // loading={tableLoading}
                        selectionMode='single'
                        // onRowSelect={onRowSelect}
                        // selection={selectedMolecule}
                        // onSelectionChange={(e) => setSelectedMolecule(e.value)}
                        emptyMessage='No Suppliers found.'
                      >
                        <Column field='supplierName' header='Name' sortable />
                        <Column
                          field='customerAccountCode'
                          header='Account Code'
                          sortable
                        />
                      </DataTable>
                    </CardBody>
                  </Card>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* Payment and Bank Modals */}
      <PaymentModal
        visible={paymentModalVisible}
        setVisible={setPaymentModalVisible}
        onSave={(cardData) => {
          // Here you would typically make an API call to save the card
          console.log('Card saved for pharmacy:', cardData.pharmacyId)
          console.log('Card data:', cardData)

          // After successful payment processing, refresh the payment profile data
          if (cardData.pharmacyId) {
            fetchPaymentProfile(cardData.pharmacyId)
          }
        }}
        apiLoginID={process.env.REACT_APP_AUTHORIZE_API_LOGIN_ID}
        clientKey={process.env.REACT_APP_AUTHORIZE_CLIENT_KEY}
        pharmacyId={user?.pharmacyModules?.[0]?.pharmacyId || ''}
        userId={user?.id || ''}
      />
      <BankInfoModal
        visible={bankInfoModalVisible}
        setVisible={setBankInfoModalVisible}
        onSave={(bankData) => {
          // Here you would typically make an API call to save the bank info
          console.log('Bank info saved for pharmacy:', bankData.pharmacyId)
          console.log('Bank data:', bankData)

          // After successful bank info processing, refresh the bank profile data
          if (bankData.pharmacyId) {
            fetchBankProfile(bankData.pharmacyId)
          }
        }}
        apiLoginID={process.env.REACT_APP_AUTHORIZE_API_LOGIN_ID}
        clientKey={process.env.REACT_APP_AUTHORIZE_CLIENT_KEY}
        pharmacyId={user?.pharmacyModules?.[0]?.pharmacyId || ''}
        userId={user?.id || ''}
      />
      <DeleteModal
        state={deleteBankModalVisible}
        footer={
          <React.Fragment>
            <PrimeButton
              label='No'
              icon='pi pi-times'
              outlined
              onClick={() => setDeleteBankModalVisible(false)}
            />
            <PrimeButton
              label='Yes'
              icon='pi pi-check'
              severity='primary'
              onClick={confirmDeleteBankProfile}
            />
          </React.Fragment>
        }
        onHide={() => setDeleteBankModalVisible(false)}
        deletedItem={user?.pharmacyModules?.[0]?.pharmacyId || ''}
        name={bankProfiles?.[0]?.payment?.bankAccount?.accountNumber || ''}
      />
      <DeleteModal
        state={deleteModalVisible}
        footer={
          <React.Fragment>
            <PrimeButton
              label='No'
              icon='pi pi-times'
              outlined
              onClick={() => setDeleteModalVisible(false)}
            />
            <PrimeButton
              label='Yes'
              icon='pi pi-check'
              severity='primary'
              onClick={confirmDeleteProfile}
            />
          </React.Fragment>
        }
        onHide={() => setDeleteModalVisible(false)}
        deletedItem={user?.pharmacyModules?.[0]?.pharmacyId || ''}
        name={
          paymentProfiles?.[0]?.payment?.creditCard?.cardNumber ||
          'this payment method'
        }
      />
    </React.Fragment>
  )
}

export default UserProfile
